import { Component, OnInit } from '@angular/core';
import { AssetService } from '~/core/services/assets/asset.service';

@Component({
  selector: 'volvo-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.scss']
})
export class PrintLayoutComponent implements OnInit {
  printDate = new Date();
  constructor(public assetService: AssetService) { }

  ngOnInit(): void {
  }

}
